// Generated from SVG to Code Figma Plugin

import type { JSX } from 'react';

export const FastGenerateIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M24 8.5C32.5604 8.5 39.5 15.4396 39.5 24C39.5 32.5604 32.5604 39.5 24 39.5C15.4396 39.5 8.5 32.5604 8.5 24C8.5 15.4396 15.4396 8.5 24 8.5Z"
      fill="url(#paint0_linear_29367_21465)"
      stroke="url(#paint1_linear_29367_21465)"
    />
    <path
      d="M21.3767 16.849C21.6062 16.4109 22.0599 16.1364 22.5545 16.1364H28.6331C29.0768 16.1364 29.3254 16.6478 29.0513 16.9967L24.8523 22.3409H28.4633C29.6224 22.3409 30.2264 23.7206 29.4403 24.5722L22.6744 31.902C22.2046 32.411 21.3668 31.9518 21.543 31.2819L23.0795 25.4432H19.0723C18.073 25.4432 17.4309 24.382 17.8946 23.4967L21.3767 16.849Z"
      fill="currentColor"
    />
    <defs>
      <linearGradient id="paint0_linear_29367_21465" gradientUnits="userSpaceOnUse" x1="24" x2="24" y1="40" y2="8">
        <stop stopColor="#D9D9D9" />
        <stop offset="1" stopColor="#737373" />
      </linearGradient>
      <linearGradient id="paint1_linear_29367_21465" gradientUnits="userSpaceOnUse" x1="24" x2="24" y1="40" y2="8">
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="#999999" />
      </linearGradient>
    </defs>
  </svg>
);
